//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data: () => ({
    tabt: 0,
    state: 0,
    loading: false,
    finished: false,
    list: [],
    form: {
      title: '',
      message_type: '',
      isRead: '',
      pageIndex: 1,
      pageSize: 10
    },
    info: '',
    messageVisible: false
  }),
  methods: {
    // 切换状态
    changeTab(index) {
      this.tabt = index
      if (index == 0) {
        this.form.isRead = ''
      } else if (index == 1) {
        this.form.isRead = false
      } else if (index == 2) {
        this.form.isRead = true
      }
      this.form.pageIndex = 1;
      this.list = [];
      this.getList();
    },
    //切换消息类型
    changeState(type) {
      this.state = type
      if (type == 0) {
        this.form.message_type = ''
      } else {
        this.form.message_type = type
      }
      this.form.pageIndex = 1;
      this.list = [];
      this.getList();
    },
    // 消息列表
    getList() {
      this.loading = true;
      this.$get("/sys/user/message/list", this.form, function (res) {
        var newArr = res.data.records;
        if (!newArr || newArr.length === 0) {
          this.finished = true;
        } else {
          for (var i = 0; i < newArr.length; i++) {
            newArr[i].show = 0
          }
          this.list.push(...newArr);
          this.form.pageIndex = this.form.pageIndex + 1;
        }
        this.loading = false;
      });
    },

    // 查看消息详情
    lookMessage(id, index) {
      this.index = index
      this.messageVisible = true;
      this.$get('/sys/user/message?id=' + id, function (res) {
        if (res.code == 200) {
          this.info = res.data;
          this.readMsg(id, index);
        }
      })
    },

    // 标记消息为已读
    readMsg(id, index) {
      this.$put('/sys/user/message/read?ids=' + id, '', function (res) {
        if (res.code == 200) {
          this.list[index].isRead = true
          this.getList();
        }
      }, true)
    },

    // 点击消息处理
    getMsg(msg, id, read, index) {
      // eslint-disable-next-line no-undef
      var userType = getSession('user').currentUserType
      // eslint-disable-next-line no-undef
      var userId = getSession('user').id
      if (read == false) {
        if (index) {
          this.readMsg(id, index);
        } else {
          this.readMsg(id, this.index);
        }
      }
      if (msg.indexOf('url') != -1) {
        var url = msg.split("url='")[1]
        var urls = url.split("'>")[0]
        var finalUrl = ''
        if (userType == 3) {
          if(urls.indexOf('facilitator') != -1){
            if (urls.indexOf('/facilitator/projectProgressManage/underwayProjectInfo') != -1) {
              finalUrl = urls.replace('/facilitator/projectProgressManage/underwayProjectInfo', '/facilitator/underProInfo')
            }
            if (urls.indexOf('/facilitator/projectProgressManage/underwayProjectAuditInfo') != -1) {
              finalUrl = urls.replace('/facilitator/projectProgressManage/underwayProjectAuditInfo', '/facilitator/underProMeetInfo')
            }
            this.$router.push({
              path: finalUrl
            })
          }
          if (urls.indexOf('outsourcer') != -1) {
            this.$confirm('继续操作将切换为发包商,是否继续', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'info'
            }).then(() => {
              this.$put('/sys/user/convert/identity?currentUserType=2' + '&id=' + userId, '', function (res) {
                if (res.code == 200) {
                  if (url.indexOf('/outsourcer/projectReleaseManage/releasedProjectInfo') != -1) {
                    finalUrl = urls.replace('/outsourcer/projectReleaseManage/releasedProjectInfo', '/outsourcer/releaseProInfo')
                  }
                  if (urls.indexOf('outsourcer/projectProgressManage/underwayProjectInfo') != -1) {
                    finalUrl = urls.replace('outsourcer/projectProgressManage/underwayProjectInfo', '/outsourcer/underProInfo')
                  }
                  if (urls.indexOf('outsourcer/projectProgressManage/underwayProjectAuditInfo') != -1) {
                    finalUrl = urls.replace('outsourcer/projectProgressManage/underwayProjectAuditInfo', '/outsourcer/underProMeetInfo')
                  }
                  this.$router.push({
                    path: finalUrl
                  })
                }
              })
            })
          }
        }
        if (userType == 2) {
          if(urls.indexOf('outsourcer') != -1){
            if (url.indexOf('/outsourcer/projectReleaseManage/releasedProjectInfo') != -1) {
              finalUrl = urls.replace('/outsourcer/projectReleaseManage/releasedProjectInfo', '/outsourcer/releaseProInfo')
            }
            if (urls.indexOf('outsourcer/projectProgressManage/underwayProjectInfo') != -1) {
              finalUrl = urls.replace('outsourcer/projectProgressManage/underwayProjectInfo', '/outsourcer/underProInfo')
            }
            if (urls.indexOf('outsourcer/projectProgressManage/underwayProjectAuditInfo') != -1) {
              finalUrl = urls.replace('outsourcer/projectProgressManage/underwayProjectAuditInfo', '/outsourcer/underProMeetInfo')
            }
            this.$router.push({
              path: finalUrl
            })
          }
          if (urls.indexOf('facilitator') != -1) {
            this.$confirm('继续操作将切换为服务商,是否继续', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'info'
            }).then(() => {
              this.$put('/sys/user/convert/identity?currentUserType=2' + '&id=' + userId, '', function (res) {
                if (res.code == 200) {
                  if (urls.indexOf('/facilitator/projectProgressManage/underwayProjectInfo') != -1) {
                    finalUrl = urls.replace('/facilitator/projectProgressManage/underwayProjectInfo', '/facilitator/underProInfo')
                  }
                  if (urls.indexOf('/facilitator/projectProgressManage/underwayProjectAuditInfo') != -1) {
                    finalUrl = urls.replace('/facilitator/projectProgressManage/underwayProjectAuditInfo', '/facilitator/underProMeetInfo')
                  }
                  this.$router.push({
                    path: finalUrl
                  })
                }
              })
            })
          }
        }
        if(urls.indexOf('outsourcer')!=-1||urls.indexOf('facilitator')!=-1){
          return
        }else{
          if (urls.indexOf('/search/projectInfo') != -1) {
            finalUrl = urls.replace('/search/projectInfo', '/projectInfo')
          }
          if (urls.indexOf('/findDatum/questionInfo') != -1) {
            finalUrl = urls.replace('/findDatum/questionInfo', '/knowledge/questionInfo')
          }
          if (urls.indexOf('/findDatum/documentInfo') != -1) {
            finalUrl = urls.replace('/findDatum/documentInfo', '/knowledge/documentInfo')
          }
          if (urls.indexOf('/personCenter/authentication') != -1) {
            finalUrl = urls.replace('/personCenter/authentication', '/person/renzheng')
          }
          if (urls.indexOf('/libraryma/questionInfo') != -1) {
            finalUrl = urls.replace('/libraryma/questionInfo', '/knowledge/questionInfo')
          }
          this.$router.push({
            path: finalUrl
          })
        }
        
      }
    },

  },
  mounted() {

  },
};
